import { ORDER_ADD_SERVICE_NAME, OrderAddServiceProvider } from './order.add.service'
import { ORDER_COMPLETE_SERVICE_NAME, OrderCompleteServiceProvider } from './order.complete.service'
import { ORDER_CONFIRM_SERVICE_NAME, OrderConfirmServiceProvider } from './order.confirm.service'
import { ORDER_CONTENT_SERVICE_NAME, OrderContentServiceProvider } from './order.content.service'
import { ORDER_RELATED_PACKAGES_SERVICE_NAME, OrderRelatedPackagesServiceProvider } from './order.related-packages.service'
import { ORDER_SERVICE_NAME, OrderServiceProvider } from './order.service'

export const ORDER_SERVICES_MODULE_NAME = 'simax.services.order'

const module = angular.module(ORDER_SERVICES_MODULE_NAME, [])

module.provider(ORDER_ADD_SERVICE_NAME, OrderAddServiceProvider)
module.provider(ORDER_COMPLETE_SERVICE_NAME, OrderCompleteServiceProvider)
module.provider(ORDER_CONFIRM_SERVICE_NAME, OrderConfirmServiceProvider)
module.provider(ORDER_CONTENT_SERVICE_NAME, OrderContentServiceProvider)
module.provider(ORDER_RELATED_PACKAGES_SERVICE_NAME, OrderRelatedPackagesServiceProvider)
module.provider(ORDER_SERVICE_NAME, OrderServiceProvider)